import { render, staticRenderFns } from "./UserActivation.vue?vue&type=template&id=24722487&"
import script from "./UserActivation.vue?vue&type=script&lang=ts&"
export * from "./UserActivation.vue?vue&type=script&lang=ts&"
import style0 from "./UserActivation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports